import timings from "../../assets/dataSala/tiempoAnimacion.json";
export const SCREEN_REVEAL_SECONDS = 2.4;
export const EMPTY_REVEAL_SECONDS = 2.55;
export const EMPTY_STOP_SECONDS = 2;
export function tourDuration(salaId) {
  return (
    timings.find((entry) => Number(entry.salaId) === Number(salaId))?.winnerAnimationTime || 14000
  );
}
const clamp = (n) => Math.max(0, Math.min(1, n));
// Scene units per second. The final smoothstep has a peak derivative of 1.5;
// account for it so a distant winner never makes the camera rush to catch up.
export const CAMERA_SPEED = 3.2;
export function cameraTimings(durationMs, cruiseLength, approachLength = 0) {
  const seconds = durationMs / 1000;
  const entryEnd = Math.max(4.5, seconds * 0.115);
  const searchEnd = entryEnd + Math.max(seconds * 0.565, cruiseLength / CAMERA_SPEED);
  const approachTime = Math.max(4.5, seconds * 0.32, (1.5 * approachLength) / CAMERA_SPEED);
  return { entryEnd, searchEnd, approachTime };
}
const smooth = (n) => {
  const t = clamp(n);
  return t * t * (3 - 2 * t);
};
// Integrate a linearly decreasing speed: the camera never jumps or reverses.
export function emptyCruiseProgress(startU, seconds, cruiseSeconds) {
  const t = clamp(seconds / EMPTY_STOP_SECONDS);
  return clamp(startU + (EMPTY_STOP_SECONDS / cruiseSeconds) * (t - .5 * t * t));
}
export function emptyRevealProgress(seconds, reduced = false) {
  if (reduced) return { title: 0, fullscreen: 1, ready: true };
  return {
    title: 1 - smooth((seconds - 1.45) / .45),
    fullscreen: smooth((seconds - 1.85) / .7),
    ready: seconds >= EMPTY_REVEAL_SECONDS,
  };
}
export function screenRevealProgress(seconds, reduced = false) {
  if (reduced) return { dive: 1, background: 1, fullscreen: 1, content: 1, ready: true };
  const p = seconds / SCREEN_REVEAL_SECONDS;
  return {
    dive: smooth(p / 0.72),
    background: smooth((p - 0.12) / 0.45),
    fullscreen: smooth((p - 0.7) / 0.12),
    content: smooth((p - 0.78) / 0.22),
    ready: seconds >= SCREEN_REVEAL_SECONDS,
  };
}
